import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    mobile = '',
    password = '',
    verifyCode = '',
    codeId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.setCurrentMobile, {
        mobile,
        password,
        verifyCode,
        codeId,
    }, options);
    if (error) return { error, status };
    return content || {};
};

